module.exports = __webpack_public_path__ + "static/media/data-collection.ab686926.svg";